'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = postcode;

var _actions = require('../helpers/actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function postcode() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case 'FETCH_LOOKUP_BILL_ADDRESSES':
      return state;
    case 'FETCH_LOOKUP_BILL_ADDRESSES_SUCCESS':
      return (0, _extends3.default)({}, state, { billAddresses: action.result.map(function (r) {
          return { label: r.label, id: r.id };
        }) });
    case 'FETCH_LOOKUP_BILL_ADDRESSES_ERROR':
      return (0, _extends3.default)({}, state, { error: (0, _actions.serializableError)(action.error) });
    case 'FETCH_LOOKUP_BILL_ADDRESS':
      return state;
    case 'FETCH_LOOKUP_BILL_ADDRESS_SUCCESS':
      return (0, _extends3.default)({}, state, { billAddressDetail: action.result });
    case 'FETCH_LOOKUP_BILL_ADDRESS_ERROR':
      return (0, _extends3.default)({}, state, { error: (0, _actions.serializableError)(action.error) });
    case 'FETCH_LOOKUP_SHIP_ADDRESSES':
      return state;
    case 'FETCH_LOOKUP_SHIP_ADDRESSES_SUCCESS':
      return (0, _extends3.default)({}, state, { shipAddresses: action.result.map(function (r) {
          return { label: r.label, id: r.id };
        }) });
    case 'FETCH_LOOKUP_SHIP_ADDRESSES_ERROR':
      return (0, _extends3.default)({}, state, { error: (0, _actions.serializableError)(action.error) });
    case 'FETCH_LOOKUP_SHIP_ADDRESS':
      return state;
    case 'FETCH_LOOKUP_SHIP_ADDRESS_SUCCESS':
      return (0, _extends3.default)({}, state, { shipAddressDetail: action.result });
    case 'FETCH_LOOKUP_SHIP_ADDRESS_ERROR':
      return (0, _extends3.default)({}, state, { error: (0, _actions.serializableError)(action.error) });
    default:
      return state;
  }
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/reducers/postcode.js
// module id = 2536
// module chunks = 0